/* HUX Portfolio: eigene URL pro Projekt, ohne das Erlebnis zu veraendern.
   - Inhalte der nicht aktiven Projekte liegen als <template> im HTML und werden beim Wechsel eingesetzt.
   - Jeder Wechsel setzt die Projekt-URL (pushState), Titel, Description, Canonical und hreflang.
   - Zurueck/Vorwaerts im Browser wechselt das Projekt.
   - Alte Links mit #projekt werden auf die Projekt-URL umgestellt. */
(function () {
  var root = document.querySelector('.js-hux-portfolio');
  if (!root) return;
  var wrap = root.closest('[data-hux-hub-url]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.js-portfolio-link-tab'));
  if (!tabs.length) return;

  var hubUrl = wrap ? wrap.getAttribute('data-hux-hub-url') : '';
  var hubTitle = document.title;
  var hubDesc = (document.querySelector('meta[name="description"]') || {}).content || '';
  var isHub = hubUrl && location.pathname.replace(/\/$/, '') === hubUrl.replace(/\/$/, '');
  var skipPush = false;
  var curPath = location.pathname;

  function fill(tab) {
    var box = document.getElementById(tab.getAttribute('data-tab'));
    if (!box) return;
    var tpl = box.querySelector('template.js-hux-pf-tpl');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    tpl.parentNode.removeChild(tpl);
    box.appendChild(frag);
    var anim = box.querySelectorAll('.scroll-trigger');
    for (var i = 0; i < anim.length; i++) anim[i].classList.add('scroll-trigger--offscreen');
    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      window.initializeScrollAnimationTrigger(box);
    } else {
      for (var j = 0; j < anim.length; j++) anim[j].classList.remove('scroll-trigger--offscreen');
    }
  }

  function setMeta(sel, attr, val) {
    var el = document.querySelector(sel);
    if (el && val) el.setAttribute(attr, val);
  }

  function unprefixed(path) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r !== '/' && path.indexOf(r) === 0) return '/' + path.slice(r.length);
    return path;
  }

  function updateHead(url, title, desc) {
    var oldPath = unprefixed(curPath);
    var abs = location.origin + url;
    if (title) document.title = title;
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('link[rel="canonical"]', 'href', abs);
    setMeta('meta[property="og:url"]', 'content', abs);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[name="twitter:description"]', 'content', desc);
    var newPath = unprefixed(url);
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (l) {
      try {
        var u = new URL(l.href);
        if (u.pathname.slice(-oldPath.length) === oldPath) {
          u.pathname = u.pathname.slice(0, u.pathname.length - oldPath.length) + newPath;
          l.href = u.toString();
        }
      } catch (e) {}
    });
    curPath = url;
  }

  function syncUi(tab) {
    tabs.forEach(function (t) {
      var a = t.querySelector('.hux-pf-link');
      if (a) {
        if (t === tab) a.setAttribute('aria-current', 'page');
        else a.removeAttribute('aria-current');
      }
    });
    var cur = root.querySelector('.js-hux-pf-current');
    if (cur) cur.textContent = String(tabs.indexOf(tab) + 1);
    // Footer "naechstes Projekt" mit echter URL verlinken
    var next = root.querySelector('.js-portfolio-link-tab[data-tab="' + tab.getAttribute('data-next-tab') + '"]');
    if (next && next.getAttribute('data-url')) {
      document.querySelectorAll('.js-portfolio-footer-link').forEach(function (l) {
        l.setAttribute('href', next.getAttribute('data-url'));
        l.setAttribute('data-hux-tab', next.getAttribute('data-tab'));
      });
    }
  }

  function track(tab) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'project_view', project_name: tab.getAttribute('data-project-name'), page_path: tab.getAttribute('data-url') });
    } catch (e) {}
  }

  // Vorab einsetzen, sobald jemand ein Projekt ansteuert (Maus, Tastatur, Touch)
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
    tabs.forEach(function (t) {
      t.addEventListener(ev, function () { fill(t); }, { passive: true });
    });
  });

  // Vor dem bestehenden Tab-Handler: Inhalt einsetzen, Modifier-Klicks (neuer Tab) dem Browser ueberlassen
  document.addEventListener('click', function (e) {
    var footer = e.target.closest && e.target.closest('.js-portfolio-footer-link');
    if (footer) {
      var target = footer.getAttribute('data-hux-tab');
      if (target) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) { e.stopPropagation(); return; }
        var ft = root.querySelector('.js-portfolio-link-tab[data-tab="' + target + '"]');
        if (ft) fill(ft);
        footer.setAttribute('href', '#' + target);
        setTimeout(function () { syncUi(root.querySelector('.js-portfolio-link-tab.active') || ft); }, 0);
      }
      return;
    }
    var link = e.target.closest && e.target.closest('.hux-pf-link');
    var tab = e.target.closest && e.target.closest('.js-portfolio-link-tab');
    if (!tab || !root.contains(tab)) return;
    if (link) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) { e.stopPropagation(); return; }
      e.preventDefault();
    }
    fill(tab);
  }, true);

  // Nach dem bestehenden Tab-Handler: URL und Kopfdaten nachfuehren
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var url = t.getAttribute('data-url');
      syncUi(t);
      if (!url) return;
      var title = t.getAttribute('data-title');
      var desc = t.getAttribute('data-desc');
      if (!skipPush && location.pathname !== url) {
        history.pushState({ huxTab: t.getAttribute('data-tab') }, '', url);
        track(t);
      }
      updateHead(url, title, desc);
      isHub = false;
    });
  });

  window.addEventListener('popstate', function () {
    var path = location.pathname;
    var t = null;
    tabs.forEach(function (x) { if (x.getAttribute('data-url') === path) t = x; });
    var toHub = !t && hubUrl && path.replace(/\/$/, '') === hubUrl.replace(/\/$/, '');
    if (toHub) t = tabs[0];
    if (!t) return;
    skipPush = true;
    fill(t);
    if (!t.classList.contains('active')) t.click();
    else syncUi(t);
    skipPush = false;
    if (toHub) {
      document.title = hubTitle;
      updateHead(path, hubTitle, hubDesc);
      isHub = true;
    } else {
      updateHead(path, t.getAttribute('data-title'), t.getAttribute('data-desc'));
    }
  });

  // Alte Links /pages/portfolio#biotta: Projekt zeigen und URL umstellen
  function fromHash() {
    var h = decodeURIComponent((location.hash || '').replace('#', '')).toLowerCase();
    if (!h || h.indexOf('portfolio-tab-') === 0) return;
    var alias = { 'kunzli-shoes': 'kuenzli-shoes', 'kuenzli-shoes': 'kunzli-shoes', 'frank-sitzmoebel': 'frank-sitzmobel-fsm' };
    var t = null;
    tabs.forEach(function (x) {
      var n = x.getAttribute('data-project-name'), hd = x.getAttribute('data-handle');
      if (h === n || h === hd || alias[h] === n || alias[h] === hd) t = x;
    });
    if (!t) return;
    fill(t);
    skipPush = true;
    if (!t.classList.contains('active')) t.click(); else syncUi(t);
    skipPush = false;
    var url = t.getAttribute('data-url');
    if (url) {
      history.replaceState({ huxTab: t.getAttribute('data-tab') }, '', url);
      updateHead(url, t.getAttribute('data-title'), t.getAttribute('data-desc'));
    }
  }

  var active = root.querySelector('.js-portfolio-link-tab.active') || tabs[0];
  syncUi(active);
  if (isHub && location.hash) fromHash();
  window.addEventListener('hashchange', fromHash);
  window.addEventListener('load', function () { syncUi(root.querySelector('.js-portfolio-link-tab.active') || active); });

  // Mobile: sanfte Kante rechts, solange weitere Projekte folgen
  var strip = root.querySelector('.project-image-group');
  if (strip) {
    var edge = function () {
      var more = strip.scrollWidth - strip.clientWidth - strip.scrollLeft > 4;
      strip.classList.toggle('hux-more', more);
    };
    strip.addEventListener('scroll', edge, { passive: true });
    window.addEventListener('resize', edge);
    edge();
  }
})();
